import React, { useState, useEffect } from "react";
import {
 createDailySentence,
 updateDailySentence,
 fetchCategories,
} from "./adminDailySentenceService";
import "../../styles/content.css";

const LEVELS = [
 { name: "EASY", display: "Easy" },
 { name: "MEDIUM", display: "Medium" },
 { name: "HARD", display: "Hard" },
];

const DailySentenceForm = ({ sentence, onSaved, onCancel }) => {
 const isEdit = !!sentence;
 const [form, setForm] = useState({
 title: "", description: "", pronunciation: "", phoneticSpelling: "",
 categoryId: "", level: "",
 });
 const [categories, setCategories] = useState([]);
 const [loading, setLoading] = useState(false);

 useEffect(() => {
 loadCategories();
 if (sentence) {
 setForm({
 title: sentence.title || "",
 description: sentence.description || "",
 pronunciation: sentence.pronunciation || "",
 phoneticSpelling: sentence.phoneticSpelling || "",
 categoryId: sentence.categoryId || "",
 level: sentence.level || "",
 });
 }
 }, [sentence]);

 const loadCategories = async () => {
 const res = await fetchCategories();
 if (res.status === 200) {
 const list = Array.isArray(res.data) ? res.data : res.data?.data || [];
 setCategories(list);
 } else {
 }
 };

 const handleChange = (e) => {
 setForm({ ...form, [e.target.name]: e.target.value });
 };

 const handleSubmit = async () => {
 if (!form.title || !form.categoryId || !form.level) {
 alert("Title, Category and Level are required");
 return;
 }

 const payload = {
 title: form.title,
 categoryId: Number(form.categoryId),
 level: form.level,
 ...(form.description && { description: form.description }),
 ...(form.pronunciation && { pronunciation: form.pronunciation }),
 ...(form.phoneticSpelling && { phoneticSpelling: form.phoneticSpelling }),
 };

 setLoading(true);
 const res = isEdit
 ? await updateDailySentence(sentence.id, payload)
 : await createDailySentence(payload);
 if (res.status === 200 || res.status === 201) {
 onSaved();
 } else {
 alert(res.message || "Operation failed");
 }
 setLoading(false);
 };

 return (
 <div className="modal-overlay">
 <div className="modal-content">
 <div className="form-card" style={{ margin: 0, boxShadow: "none" }}>
 <h2>{isEdit ? "Edit" : "Create"} Daily Sentence</h2>

 <div className="form-group">
 <label>Sentence / Title *</label>
 <input name="title" placeholder="e.g. How are you doing today?" value={form.title} onChange={handleChange} />
 </div>

 <div className="form-group">
 <label>Description</label>
 <textarea name="description" placeholder="Brief meaning or context..." value={form.description} onChange={handleChange} rows={2} />
 </div>

 <div className="form-group">
 <label>Pronunciation (IPA)</label>
 <input name="pronunciation" placeholder="e.g. /haʊ ɑːr juː/" value={form.pronunciation} onChange={handleChange} />
 </div>

 <div className="form-group">
 <label>Phonetic Spelling</label>
 <input name="phoneticSpelling" placeholder="e.g. how ar yoo doo-ing tuh-day" value={form.phoneticSpelling} onChange={handleChange} />
 </div>

 <div className="form-group">
 <label>Category *</label>
 <select name="categoryId" value={form.categoryId} onChange={handleChange}>
 <option value="">Select Category</option>
 {categories.map((c) => (
 <option key={c.id} value={c.id}>{c.icon} {c.title} ({c.categoryName || c.category})</option>
 ))}
 </select>
 </div>

 <div className="form-group">
 <label>Level *</label>
 <select name="level" value={form.level} onChange={handleChange}>
 <option value="">Select Level</option>
 {LEVELS.map((l) => (
 <option key={l.name} value={l.name}>{l.display}</option>
 ))}
 </select>
 </div>

 <div className="form-actions">
 <button onClick={handleSubmit} disabled={loading}>
 {loading ? "Saving..." : isEdit ? "Update" : "Create"}
 </button>
 <button onClick={onCancel} disabled={loading}>Cancel</button>
 </div>
 </div>
 </div>
 </div>
 );
};

export default DailySentenceForm;
